import React from "react";
import { applyFilters } from "../../../Utils/FiltersManager";
import { applySort } from "../../../Utils/SortManager";
import { handleUpdateSelected } from "../../../Utils/DocsManager";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const Plan01Actions = ({
  data,
  filter,
  instanceId,
  modelId,
  selectedDocuments,
  setSelectedDocuments,
  configkeyset,
  instanceStatus,
  t,
  isInstanceEditable,
}) => {
  const navigate = useNavigate();
  const role = Cookies.get("Role")
  const backUrl = role=="superadmin" ? `/Admin/AdmLotsTable` : `/User/${configkeyset}`;

  const handleQualifyClick = () => {
    const filteredDocuments = applySort(applyFilters(data, filter));
    const documentsJson = JSON.stringify(filteredDocuments);
    let newWindow;

    localStorage.setItem("docs", documentsJson);
    localStorage.setItem("modelId", modelId);
    localStorage.setItem("instanceId", instanceId);
    localStorage.setItem("tabOpen", true);

    if (role == "superadmin"){
      newWindow = window.open("/Admin/DocView", "_blank");
    } else {
      newWindow = window.open("/User/DocView", "_blank");
    }

    const intervalId = setInterval(() => {
      if (newWindow.closed) {
        clearInterval(intervalId);
        localStorage.removeItem("tabOpen");
        window.location.reload();
      }
    }, 1000);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#F7F9F9",
        padding:"10px", 
      }}
    >
      {isInstanceEditable(instanceStatus) ? (
        <button
          type="button"
          className="btn btn-primary"
          style={{ marginLeft: "2.5px", marginRight: "2.5px" }}
          onClick={handleQualifyClick}
        >
          {t("Qualify")}
        </button>
      ) : (
        <button className="btn btn-primary" disabled>
          {t("Qualify")}
        </button>
      )}
      <button
        className="btn btn-danger"
        style={{ marginLeft: "2.5px", marginRight: "2.5px" }}
        onClick={() => navigate(backUrl)}
      >
        {t("Back")}
      </button>
      {isInstanceEditable(instanceStatus) ? (
        <button
          style={{ marginLeft: "2.5px", marginRight: "2.5px" }}
          className="btn btn-primary"
          onClick={() =>
            handleUpdateSelected(
              selectedDocuments,
              setSelectedDocuments,
              data,
              instanceId
            )
          }
        >
          {t("Update selected")}
        </button>
      ) : (
        <button className="btn btn-primary" disabled>
          {t("Update selected")}
        </button>
      )}
    </div>
  );
};

export default Plan01Actions;
